import { Star } from 'lucide-react';

import { cn } from '@/shared/utils/cn';

import type { CourseCardItem } from '../types/course-card';
import {
  formatCourseCardCount,
  formatCourseCardModality,
  formatCourseCardRating,
} from '../lib/course-card-formatters';

interface CourseCardMetaRowProps {
  course: CourseCardItem;
}

export function CourseCardMetaRow({ course }: CourseCardMetaRowProps) {
  const isLive = course.modality === 'en-vivo';
  const hasRating = course.rating > 0;

  return (
    <div className="text-(--text-secondary) flex min-h-5 flex-wrap items-center gap-x-2 gap-y-1 text-[0.75rem] font-medium">
      {hasRating ? (
        <>
          <span className="inline-flex items-center gap-1">
            <Star
              aria-hidden="true"
              className="fill-(--course-rating-star) text-(--course-rating-star) h-3 w-3"
            />
            <span className="text-navy tabular-nums">{formatCourseCardRating(course.rating)}</span>
            <span>({formatCourseCardCount(course.studentsCount)})</span>
          </span>
          <span aria-hidden="true" className="text-(--color-border-strong)">
            |
          </span>
        </>
      ) : null}
      <span className="inline-flex items-center gap-1.5">
        <span
          aria-hidden="true"
          className={cn(
            'relative h-1.5 w-1.5 rounded-full',
            isLive ? 'bg-(--course-live)' : 'bg-(--color-primary-500)',
          )}
        >
          {isLive ? (
            <span className="bg-(--course-live-soft) absolute inset-[-0.18rem] animate-ping rounded-full motion-reduce:animate-none" />
          ) : null}
        </span>
        {formatCourseCardModality(course.modality)}
      </span>
    </div>
  );
}
